// import { ConfigurationVariantMesh } from '../Configuration/configurationVariantMesh';
import { EngineBuilder } from './engineBuilder';
import { ConfigurationTranslation } from '../Configuration/configurationTranslation';
import { ConfigurationTechnicalFile } from '../Configuration/configurationTechnicalFile';
import { IVariantModel } from '../Content/contentModel';
import { getQueryParam } from '../../Utils/html';
import { ConfigurationVariantMeshDior } from '../Configuration/configurationVariantMeshDior';

export class EngineConfiguration extends EngineBuilder {
    public configurationTranslation: ConfigurationTranslation

    public configurationTechnicalFile: ConfigurationTechnicalFile

    public configurationVariantMesh: ConfigurationVariantMeshDior

    protected buildConfig(): void {
        this.configurationTranslation = new ConfigurationTranslation();
        this.configurationTechnicalFile = new ConfigurationTechnicalFile(
            this.system,
            this.configurationTranslation,
            this.toolScreenshot,
            this.contentsManager
        );
        this.configurationVariantMesh = new ConfigurationVariantMeshDior(
            this.configurationTranslation,
            this.container,
            this.system,
            this.contentsManager
        );
        this.configurationVariantMesh.showVariantMeshesMaterialsList();
        this.checkParam();
    }

    protected showConfiguration(): void {
        if (this.configurationVariantMesh) this.configurationVariantMesh.show();
    }

    protected hideConfiguration(): void {
        if (this.configurationVariantMesh) this.configurationVariantMesh.hide();
    }

    public onConfirm(callback: (jsonviews) => void): void {
        this.configurationVariantMesh.confirm.addEventListener('click', () => {
            this.toolScreenshot.shotViews(null, (views) => {
                const json = this.getConfigurationJson();
                callback({ json, views });
            });
        });
    }

    public onExit(callback: () => void): void {
        this.configurationVariantMesh.exit.addEventListener('click', () => {
            callback();
        });
    }

    private checkParam() {
        const variantParam = getQueryParam('naker_config_variant');
        if (variantParam) {
            this.setConfigurationByName(variantParam);
        }
    }

    public setConfigurationByName(name: string, animate?: boolean): void {
        const model = this.contentsManager.getFirstModel();
        model.setVariantByName(name, animate);
    }

    public setConfiguration(variant: IVariantModel): void {
        const model = this.contentsManager.getFirstModel();
        model.setVariant(variant, false);
        // this.sceneryCamera.resetInitialView()
    }

    public getConfigurationJson(): string {
        const variant = this.configurationVariantMesh.getCurrentVariant();
        return JSON.stringify(variant);
    }

    public setConfigurationByJson(variantString: string): void {
        const variant = JSON.parse(variantString);
        this.setConfiguration(variant);
    }

    public setMeshesMaterial(meshes: string[], materialName: string): void {
        const model = this.contentsManager.getFirstModel();
        const material = this.system.toolMaterial.getMaterialByName(materialName);
        if (material) model.setVariantMeshes({ meshes, material: material.key }, true);
    }
}
